import { render, staticRenderFns } from "./POA.vue?vue&type=template&id=340a04ca&"
import script from "./POA.vue?vue&type=script&lang=js&"
export * from "./POA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports